import React from 'react';
import './style.css';

const SecaoCapa = () => {
  return (
    <section className="secao-capa">
      <div className="capa center">
        <div className="texto-capa">
          <p>Preços baixos em</p>
          <h1>Óculos de grau e de sol</h1>
          <p>Você só encontra aqui</p>
        </div>
      </div>
    </section>
  );
};

export default SecaoCapa;
